export const setupComponent = (app) => {
  // 自动注册common文件夹下的组件
  const commonFiles = import.meta.glob('./common/*/*.vue')
  for (let [key, value] of Object.entries(commonFiles)) {
    // 截取路径作为组件名，例如 ./ButtonDialogQqMapSelect/index.vue，截取 ButtonDialogQqMapSelect
    const name = key.split('/').splice(-2)[0]

    app.component(name, defineAsyncComponent(value))
  }

  // 注册EasyUI通用组件
  app.component(
    'DialogPanelForm',
    defineAsyncComponent(() => import('@/components/EasyUI/DialogPanelForm/index.vue'))
  )
  app.component(
    'PanelList',
    defineAsyncComponent(() => import('@/components/EasyUI/PanelList/index.vue'))
  )

  // 其它业务组件
  app.component(
    'StaffCell',
    defineAsyncComponent(() => import('@/components/biz/StaffCell.vue'))
  )
}
